import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "contentType" }, "Type", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "landingpage" }, "Landing Page", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "contentName" }, "Name", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add content",
    onConfirm: _ctx.onConfirm,
    onCancel: _ctx.onClose,
    "show-footer": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("select", {
            type: "text",
            class: "form-control form-select",
            id: "contentType",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event))
          }, _hoisted_4, 512), [
            [_vModelSelect, _ctx.type]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "contentName",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onConfirm", "onCancel"]))
}